import _asyncToGenerator from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import './Curators.css';
import React, { useEffect } from 'react';
import { get, getDictionaryItem, injectImageResolution, pathJoin, getMediaHost, isChina, getListingItemURL, generatrURLFromTags, getGlobalDictionaryTerm, getColorByTheme, canUseDOM, getPageThemeColors } from '../../utils';
import LazyPicture from '../atoms/LazyPicture';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { ReactComponent as IconChevronRightLight } from '../../resources/icons/chevron-right-light.svg';
import { ReactComponent as IconTwitterX } from '../../resources/icons/twitterX.svg';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import RouterLink from '../atoms/RouterLink/RouterLink';
import getListing, { loadCategoryAlgoliaResults } from '../../utils/getListing';
import Video from '../atoms/Video';
import { tealiumClickFunc, tealiumMergeClickData, getLinkDomain } from '../../utils/tealium';
import ScrollAnimation from 'react-animate-on-scroll';

//pesonlization
import { resolveListPersonalization } from '../../utils/resolveListPersonalization';
import { algoliaScoredCondition } from '../../utils/algoliaScoredCondition';
import { usePersonalizedList } from '@uniformdev/personalize-react';
import { useIsVisible } from '../../utils/useIsVisible';
import { convertToAnalyticObject } from '../../utils/analytics';
var BASE_URL = process.env.REACT_APP_MEDIA_HOST ? process.env.REACT_APP_MEDIA_HOST : '';
export var CuratorBlock = function CuratorBlock(_ref) {
  var item = _ref.item,
    _ref$hostLink = _ref.hostLink,
    hostLink = _ref$hostLink === void 0 ? '' : _ref$hostLink,
    _ref$analytics = _ref.analytics,
    analytics = _ref$analytics === void 0 ? {} : _ref$analytics,
    _ref$meet = _ref.meet,
    meet = _ref$meet === void 0 ? {} : _ref$meet,
    parentParams = _ref.parentParams,
    selectedPrimaryColor = _ref.selectedPrimaryColor;
  var imgSrc = injectImageResolution("".concat(pathJoin([getMediaHost(), item.image])), 337, 225);
  var linkedinUrl = get(item, 'linkedin');
  var instagramUrl = get(item, 'instagram');
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    china = _React$useState2[0],
    setIsChina = _React$useState2[1];
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var korean = get(sitecoreContext, 'language') === 'ko';
  var newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || 'Opens in a new window';
  var BackgroundColorHex = get(parentParams, 'BackgroundColorHex');
  var activeColor = BackgroundColorHex ? BackgroundColorHex : selectedPrimaryColor;
  useEffect(function () {
    setIsChina(isChina());
  });
  var facebook = get(item, 'facebook');
  var twitter = get(item, 'twitter');
  var youtube = get(item, 'youtube');
  var whatsapp = get(item, 'whatsapp');
  var wechat = get(item, 'wechat');
  var weibo = get(item, 'weibo');
  var phone = get(item, 'TELPhone');
  var email = get(item, 'Email');
  var videoSrc = get(item, 'mediaUrl');
  var eventsAnalytics = analytics.eventsAnalytics,
    params = analytics.params;
  var editable = get(item, 'editable');
  var title = {
    value: get(item, 'title')
  };
  var curatorRole = {
    value: get(item, 'curatorRole')
  };
  var introText = {
    value: get(item, 'introText')
  };
  var showSeparator = !isChina() ? !!(linkedinUrl || instagramUrl || facebook || twitter || youtube || phone || email) : !!(whatsapp || wechat || weibo || phone || email);
  return /*#__PURE__*/React.createElement("div", {
    className: "curator curator--item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "image__container"
  }, videoSrc && /*#__PURE__*/React.createElement(Video, {
    buttonTopAlignment: true,
    className: "media-wrapper__video ",
    videoSrc: BASE_URL + videoSrc,
    videoType: "internal",
    loop: true,
    click: function click(e) {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['videoAnalytics'], params), [e, item.englishTitle]);
    }
  }), item.image && /*#__PURE__*/React.createElement(React.Fragment, null, item.url ? /*#__PURE__*/React.createElement(RouterLink, {
    className: "btn-tertiary",
    title: item.englishTitle,
    "aria-label": item.englishTitle,
    "aria-labelledby": item.englishTitle,
    href: getListingItemURL(hostLink, item.urlSlug, item.url),
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['bannerClickAnalytics'], params), item.englishTitle);
    }
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: imgSrc
  }), /*#__PURE__*/React.createElement("img", {
    className: "curator__image",
    src: imgSrc,
    alt: "Curator Image",
    "aria-hidden": "true"
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LazyPicture, {
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: imgSrc
  }), /*#__PURE__*/React.createElement("img", {
    className: "curator__image",
    src: imgSrc,
    alt: "Curator Image",
    "aria-hidden": "true"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "curator__content"
  }, title ? /*#__PURE__*/React.createElement(RouterLink, {
    className: "btn-tertiary",
    title: item.title,
    "aria-label": item.title,
    "aria-labelledby": item.title,
    href: getListingItemURL(hostLink, item.urlSlug, item.url),
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['titleClickAnalytics'], params), item.englishTitle);
    }
  }, ' ', /*#__PURE__*/React.createElement(Text, {
    editable: editable,
    className: "curator__name",
    tag: "h4",
    field: title
  })) : null, /*#__PURE__*/React.createElement(Text, {
    editable: editable,
    className: "curator__position",
    tag: "span",
    field: curatorRole
  }), /*#__PURE__*/React.createElement(Text, {
    editable: editable,
    className: "curator__info",
    tag: "p",
    field: introText
  }), item.url && /*#__PURE__*/React.createElement(RouterLink, {
    className: "btn-tertiary",
    title: item.title,
    "aria-label": item.title,
    "aria-labelledby": item.title,
    href: getListingItemURL(hostLink, item.urlSlug, item.url),
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['ctaClickAnalytics'], params), item.ctaLabel ? item.ctaLabel : item.englishTitle);
    }
  }, item.ctaLabel ? /*#__PURE__*/React.createElement("span", {
    className: "btn-tertiary__text"
  }, item.ctaLabel) : korean ? /*#__PURE__*/React.createElement("span", {
    className: "btn-tertiary__text"
  }, ' ', item.title, " ", meet) : /*#__PURE__*/React.createElement("span", {
    className: "btn-tertiary__text"
  }, ' ', meet, " ", item.title), /*#__PURE__*/React.createElement(IconChevronRightLight, {
    className: "btn-tertiary__icon"
  })), showSeparator && /*#__PURE__*/React.createElement("div", {
    className: "curator__separator"
  }), linkedinUrl && !china && /*#__PURE__*/React.createElement("a", {
    className: "c-media__link",
    target: "_blank",
    rel: "noopener noreferrer",
    href: linkedinUrl,
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['socialAnalytics'], params), "".concat(getLinkDomain(linkedinUrl), ": ").concat(item.englishTitle));
    },
    title: "Linkedin media link | ".concat(newWindowLabel),
    "aria-label": "Linkedin media link | ".concat(newWindowLabel),
    "aria-labelledby": "Linkedin media link | ".concat(newWindowLabel)
  }, /*#__PURE__*/React.createElement("svg", {
    className: "c-link__icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    viewBox: "0 0 14 14"
  }, /*#__PURE__*/React.createElement("path", {
    fill: activeColor,
    fillRule: "nonzero",
    d: "M3.163 13.797c0 .159-.044.203-.203.203H.432c-.159 0-.212-.044-.203-.203V4.826c-.009-.16.053-.212.203-.204H2.96c.168-.008.203.045.203.204v8.97zM1.7 3.412C.767 3.42 0 2.642 0 1.706 0 .822.687.009 1.692 0 2.643 0 3.4.716 3.4 1.706c0 .972-.74 1.697-1.7 1.706zM13.736 14H11.26c-.203 0-.212-.009-.212-.221V9.245c0-.433-.008-.857-.132-1.273-.194-.645-.616-.954-1.286-.972-.476-.009-.925.08-1.269.45-.264.292-.387.655-.431 1.035-.036.345-.062.698-.062 1.052a344.74 344.74 0 0 0 0 4.269c0 .15-.044.194-.194.194H5.128c-.15 0-.203-.044-.203-.194.009-2.997.009-5.993 0-8.989 0-.16.053-.195.203-.195h2.431c.16 0 .203.053.203.204-.009.327 0 .663 0 .99.458-.672 1.075-1.114 1.85-1.3a4.028 4.028 0 0 1 2.635.212c.82.354 1.26 1.026 1.489 1.857.158.539.229 1.096.238 1.661L14 13.744C14 14 14 14 13.736 14z"
  }))), instagramUrl && !china && /*#__PURE__*/React.createElement("a", {
    className: "c-media__link",
    target: "_blank",
    rel: "noopener noreferrer",
    href: instagramUrl,
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['socialAnalytics'], params), item.englishTitle);
    },
    title: "Instagram media link | ".concat(newWindowLabel),
    "aria-label": "Instagram media link | ".concat(newWindowLabel),
    "aria-labelledby": "Instagram media link | ".concat(newWindowLabel)
  }, /*#__PURE__*/React.createElement("svg", {
    className: "c-link__icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/React.createElement("path", {
    fill: activeColor,
    fillRule: "nonzero",
    d: "M9.979.668c1.396.003 1.716.015 2.458.05 3.029.138 4.71 1.823 4.846 4.847.036.777.047 1.092.05 2.674v1.522c-.003 1.583-.015 1.897-.05 2.675-.137 3.03-1.823 4.708-4.847 4.847-.778.036-1.092.047-2.675.05H8.239c-1.583-.003-1.897-.014-2.675-.05-3.03-.139-4.708-1.82-4.847-4.847a44.494 44.494 0 0 1-.05-2.457V8.02c.004-1.395.016-1.716.05-2.457C.857 2.534 2.538.856 5.565.717 6.259.685 6.584.672 7.772.668h2.207zM9 4.72a4.28 4.28 0 1 0 0 8.558 4.28 4.28 0 0 0 0-8.558zm0 1.501a2.778 2.778 0 1 1 0 5.556 2.778 2.778 0 0 1 0-5.556zm4.449-2.67a1 1 0 1 0-.001 2 1 1 0 0 0 0-2z"
  }))), facebook && !china && /*#__PURE__*/React.createElement("a", {
    className: "c-media__link",
    target: "_blank",
    rel: "noopener noreferrer",
    href: facebook,
    title: "Facebook media link | ".concat(newWindowLabel),
    "aria-label": "Facebook media link | ".concat(newWindowLabel),
    "aria-labelledby": "Facebook media link | ".concat(newWindowLabel)
  }, /*#__PURE__*/React.createElement("svg", {
    className: "c-link__icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "20",
    viewBox: "0 0 10 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5,6.667H0V10H2.5V20H6.667V10H9.7L10,6.667H6.667V5.277c0-.8.16-1.11.929-1.11H10V0H6.827C3.83,0,2.5,1.32,2.5,3.846v2.82Z",
    fill: activeColor
  }))), twitter && !china && /*#__PURE__*/React.createElement("a", {
    className: "c-media__link",
    target: "_blank",
    rel: "noopener noreferrer",
    href: twitter,
    title: "Twitter media link | ".concat(newWindowLabel),
    "aria-label": "Twitter media link | ".concat(newWindowLabel),
    "aria-labelledby": "Twitter media link | ".concat(newWindowLabel)
  }, /*#__PURE__*/React.createElement(IconTwitterX, {
    className: "c-link__icon twitterIcon"
  })), youtube && !china && /*#__PURE__*/React.createElement("a", {
    className: "c-media__link",
    target: "_blank",
    rel: "noopener noreferrer",
    href: youtube,
    title: "Youtube media link | ".concat(newWindowLabel),
    "aria-label": "Youtube media link | ".concat(newWindowLabel),
    "aria-labelledby": "Youtube media link | ".concat(newWindowLabel)
  }, /*#__PURE__*/React.createElement("svg", {
    className: "c-link__icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: "23",
    height: "18",
    viewBox: "0 0 23 18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8.184a145.019,145.019,0,0,0-14.6,0C.468.45.028,2.8,0,9c.028,6.185.464,8.549,4.2,8.816a144.724,144.724,0,0,0,14.6,0C22.532,17.55,22.972,15.2,23,9,22.972,2.815,22.536.451,18.8.184ZM8.625,13V5l7.667,3.993Z",
    transform: "translate(0 0)",
    fill: activeColor
  }))), whatsapp && !china && /*#__PURE__*/React.createElement("a", {
    className: "c-media__link",
    target: "_blank",
    rel: "noopener noreferrer",
    href: whatsapp,
    title: "Whatsapp media link | ".concat(newWindowLabel),
    "aria-label": "Whatsapp media link | ".concat(newWindowLabel),
    "aria-labelledby": "Whatsapp media link | ".concat(newWindowLabel)
  }, /*#__PURE__*/React.createElement("svg", {
    className: "c-link__icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5,14.382c-.3-.149-1.767-.867-2.04-.967s-.473-.148-.672.15-.771.966-.945,1.164-.349.223-.647.075a8.206,8.206,0,0,1-2.4-1.475A8.936,8.936,0,0,1,9.132,11.27c-.175-.3-.019-.458.13-.606s.3-.347.448-.52a1.992,1.992,0,0,0,.3-.5.541.541,0,0,0-.025-.52c-.075-.149-.672-1.612-.92-2.207-.243-.579-.49-.5-.672-.51s-.374-.01-.573-.01a1.1,1.1,0,0,0-.8.372A3.327,3.327,0,0,0,5.978,9.251,5.764,5.764,0,0,0,7.2,12.325a13.282,13.282,0,0,0,5.1,4.487,17.3,17.3,0,0,0,1.7.626,4.1,4.1,0,0,0,1.88.117A3.075,3.075,0,0,0,17.9,16.142a2.467,2.467,0,0,0,.174-1.413c-.074-.124-.273-.2-.572-.347m-5.448,7.4h0a9.955,9.955,0,0,1-5.057-1.379l-.361-.213-3.759.982,1-3.648-.236-.374A9.881,9.881,0,0,1,12.054,2.009a9.888,9.888,0,1,1,0,19.776M20.5,3.488a11.961,11.961,0,0,0-20.4,8.4,11.841,11.841,0,0,0,1.6,5.945L0,24l6.335-1.654a11.987,11.987,0,0,0,5.71,1.448h0A11.939,11.939,0,0,0,24,11.9a11.792,11.792,0,0,0-3.5-8.413",
    fill: activeColor
  }))), weibo && /*#__PURE__*/React.createElement("a", {
    className: "c-media__link",
    target: "_blank",
    rel: "noopener noreferrer",
    href: weibo,
    title: "Wiebo media link | ".concat(newWindowLabel),
    "aria-label": "Wiebo media link | ".concat(newWindowLabel),
    "aria-labelledby": "Wiebo media link | ".concat(newWindowLabel)
  }, /*#__PURE__*/React.createElement("svg", {
    className: "c-link__icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: "25.001",
    height: "19.792",
    viewBox: "0 0 25.001 19.792"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.308,9.737c1.5-.1,4.692-1.715,6.1-.135.621.7.383,1.943,0,2.906,1.752.923,3.856,1.382,3.507,4.122a5.141,5.141,0,0,1-.911,2.094c-2.961,3.992-11.892,5.67-17.469,2.635C1.667,20.341-.269,18.852.03,15.885c.257-2.553,2.04-4.53,3.788-6.215A12.4,12.4,0,0,1,9.641,6.224c2.6-.63,3.365,1.457,2.666,3.513Zm-2.526,2.3a10.037,10.037,0,0,0-4.49,1.284,5.031,5.031,0,0,0-2.666,3.107c-.709,3.371,3.1,4.955,5.893,5.135,3.23.21,6.463-.889,8-2.567a4,4,0,0,0,1.122-2.635c-.008-3.357-4.4-4.6-7.857-4.324ZM13.813,16.2c1.471,4.488-6.194,6.576-7.595,2.718-.938-2.58,1.314-4.631,3.66-4.879a3.549,3.549,0,0,1,3.935,2.16ZM9.006,19.737c1.428-.32,1.62-2.852-.536-2.377C6.66,17.758,7.01,20.184,9.006,19.737ZM11.454,17c-.083-.517-1.078-.44-1.071.287A.58.58,0,0,0,11.454,17ZM24.978,8.966c.1,1.355-.119,2.978-.97,3.058-1.39.13-.665-1.478-.646-2.447A4.619,4.619,0,0,0,18.9,4.821c-.634,0-2.1.45-1.877-.952.1-.617.6-.609,1.1-.679A5.977,5.977,0,0,1,24.978,8.966Zm-4.019-.1c.165,1.138-.178,2.124-.865,2.167-1.147.073-.718-.745-.788-1.719a2.043,2.043,0,0,0-1.023-1.495c-.9-.4-2.283.29-2.283-.9,0-.881.8-.79,1.26-.822a3.35,3.35,0,0,1,3.7,2.765Z",
    transform: "translate(0.001 -3.125)",
    fill: activeColor
  }))), wechat && /*#__PURE__*/React.createElement("a", {
    className: "c-media__link",
    target: "_blank",
    rel: "noopener noreferrer",
    href: wechat,
    title: "Wechat media link | ".concat(newWindowLabel),
    "aria-label": "Wechat media link | ".concat(newWindowLabel),
    "aria-labelledby": "Wechat media link | ".concat(newWindowLabel)
  }, /*#__PURE__*/React.createElement("svg", {
    className: "c-link__icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: "23.985",
    height: "20.681",
    viewBox: "0 0 23.985 20.681"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.663,10.912A7.744,7.744,0,0,1,22.679,12.4a5.689,5.689,0,0,1-.658,7.934c-.686.61-.933,1.11-.493,1.913a2.282,2.282,0,0,1,.138.523,7.568,7.568,0,0,0-2.04-.857,11.507,11.507,0,0,0-2.125.4,7.1,7.1,0,0,1-5.758-1.879c-3.071-2.84-2.633-7.2.92-9.523ZM5.573,2.534a8.883,8.883,0,0,1,9.706,2.844,6.648,6.648,0,0,1,1.385,3.515,8.505,8.505,0,0,0-5.734,2.316,6.807,6.807,0,0,0-2.115,5.769c-.87-.108-1.663-.227-2.46-.294a1.538,1.538,0,0,0-.836.141c-.774.437-1.516.93-2.395,1.48.161-.73.266-1.369.45-1.984a.753.753,0,0,0-.343-1A6.782,6.782,0,0,1,.275,7.705a7.54,7.54,0,0,1,5.3-5.17Zm8.074,10.81A.83.83,0,1,0,13.641,15a.83.83,0,1,0,.005-1.66Zm5.167,0a.83.83,0,0,0-.823.794.816.816,0,1,0,.823-.794ZM11.764,6.96a1.027,1.027,0,0,0-1,1.012,1,1,0,0,0,1.03.98,1,1,0,1,0-.027-1.992Zm-6.335,0a1,1,0,0,0-1.037.964.985.985,0,0,0,.976,1.022,1.012,1.012,0,0,0,1.049-.96A1.027,1.027,0,0,0,5.429,6.96Z",
    transform: "translate(0 -2.092)",
    fill: activeColor
  }))), phone && /*#__PURE__*/React.createElement("a", {
    className: "c-media__link",
    target: "_blank",
    rel: "noopener noreferrer",
    href: "tel:".concat(phone),
    title: "Phone media link | ".concat(newWindowLabel),
    "aria-label": "Phone media link | ".concat(newWindowLabel),
    "aria-labelledby": "Phone media link | ".concat(newWindowLabel)
  }, /*#__PURE__*/React.createElement("svg", {
    className: "c-link__icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: "13.474",
    height: "20.322",
    viewBox: "0 0 13.474 20.322"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 80",
    transform: "translate(-464.8 -2413.878)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 61",
    transform: "translate(465 2414.078)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 112",
    d: "M19.329,21.422H8.745A1.249,1.249,0,0,1,7.5,20.177V2.745A1.249,1.249,0,0,1,8.745,1.5H19.329a1.249,1.249,0,0,1,1.245,1.245V20.177A1.249,1.249,0,0,1,19.329,21.422ZM8.745,2.745V20.177H19.329V2.745Z",
    transform: "translate(-7.5 -1.5)",
    fill: activeColor,
    stroke: activeColor,
    "stroke-width": "0.4"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 63",
    transform: "translate(470.604 2428.265)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 114",
    d: "M17.745,28.745h-.623a.623.623,0,0,1,0-1.245h.623a.623.623,0,0,1,0,1.245Z",
    transform: "translate(-16.5 -27.5)",
    fill: activeColor,
    stroke: activeColor,
    "stroke-width": "0.4"
  }))))), email && /*#__PURE__*/React.createElement("a", {
    className: "c-media__link",
    target: "_blank",
    rel: "noopener noreferrer",
    href: "mailto:".concat(email),
    title: "Email media link | ".concat(newWindowLabel),
    "aria-label": "Email media link | ".concat(newWindowLabel),
    "aria-labelledby": "Email media link | ".concat(newWindowLabel)
  }, /*#__PURE__*/React.createElement("svg", {
    className: "c-link__icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: "17",
    height: "30",
    viewBox: "0 0 17 30"
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": "@",
    transform: "translate(0 23)",
    fill: activeColor,
    "font-size": "20",
    "font-family": "var(--site-font-family)",
    "font-weight": "500"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0",
    y: "0"
  }, "@"))))));
};
export var Curators = function Curators(_ref2) {
  var fields = _ref2.fields,
    params = _ref2.params,
    route = _ref2.route;
  var _React$useState3 = React.useState([]),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    searchResults = _React$useState4[0],
    setSearchResults = _React$useState4[1];
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var _React$useState5 = React.useState(''),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    seeMoreURLTags = _React$useState6[0],
    setSeeMoreURLTags = _React$useState6[1];
  var isPersonalised = get(sitecoreContext, 'isPersonalised');
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var overviewButton = get(fields, 'data.overviewButton');
  var hasOverviewButtonTitle = get(overviewButton, 'title.jss.value');
  var overviewButtonTitle = get(overviewButton, 'title.jss');
  var useCustomListingPage = get(fields, 'data.datasource.useCustomListingPage.jss.value');
  var considerPageLevelTags = get(fields, 'data.datasource.considerPageLevelTags.jss.value');
  var listingPageLink = get(fields, 'data.datasource.listingPageLink.jss.url');
  var overviewButtonUrl = useCustomListingPage ? listingPageLink : get(overviewButton, 'link.jss.value.href');
  var hasCuratorTitle = Boolean(get(fields, 'data.item.title.jss.value'));
  var curatorTitle = get(fields, 'data.item.title.jss');
  var SearchCount = get(params, 'SearchCount');
  var dictionary = get(fields, 'data.dictionary');
  //socail icons from Profile Cards
  var meet = getDictionaryItem(dictionary, 'meet');
  var currentPageID = get(route, 'itemId', '').split('-').join('');
  var tags = get(fields, 'data.item.tags.targetItems') || [];
  var tagsList = _toConsumableArray(tags);
  var _React$useState7 = React.useState(true),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isVdsite = _React$useState8[0],
    setIsVdsite = _React$useState8[1];
  var ref = React.useRef();
  var isVisible = useIsVisible(ref);
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  tags = tags.map(function (item) {
    var tag = get(item, 'title.jss.value') || get(item, 'name');
    if (tag) {
      return 'tags:' + tag;
    } else {
      return '';
    }
  });
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex', getColorByTheme(BackgroundColorHex));
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var styleThemeHexColor = BackgroundColorHex ? {
    '--m10-curators-background-color': BackgroundColorHex,
    '--m10-curators-background-active-color': ActiveColorHex,
    '--m10-curators-color': ColorHex
  } : {
    '--m10-curators-background-color': selectedPrimaryColor,
    '--m10-curators-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--m10-curators-color': getColorByTheme(selectedPrimaryColor)
  };
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var indexName = get(params, 'SearchIndex');
  var intents = get(fields, 'data.item.intents');
  var intentsLength = get(intents, 'targetItems.length');
  var contextItem = get(fields, 'data.contextItem');

  // Resolve used conditions based on what is selected with the integrated query
  var conditions = resolveListPersonalization(intents, sitecoreContext);

  // Holder for all condition values
  var allValues = [];

  // Iterate all conditions and determine what the current user is tagged with.
  conditions && Array.isArray(conditions) && conditions.forEach(function (condition) {
    var handler = condition.handler,
      mappings = condition.mappings;
    var conditionValues = handler.getValues({
      mappings: mappings,
      sitecoreContext: sitecoreContext
    });
    if (conditionValues) {
      allValues.push.apply(allValues, _toConsumableArray(conditionValues));
    }
  });
  var _usePersonalizedList = usePersonalizedList({
      rendering: contextItem,
      route: route,
      list: searchResults,
      conditions: [algoliaScoredCondition(allValues)]
    }),
    personalizedList = _usePersonalizedList.personalizedList,
    refreshTracking = _usePersonalizedList.refreshTracking;
  useEffect(function () {
    if (isVisible) {
      debugger;
      setSeeMoreURLTags(generatrURLFromTags(tagsList));
      if (isPersonalised && intentsLength) {
        _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var hits;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return loadCategoryAlgoliaResults(allValues || [], 'type:Curator', SearchCount, _toConsumableArray(tags), [], currentPageID ? "NOT objectID:".concat(currentPageID) : '', indexName);
              case 2:
                hits = _context.sent;
                setSearchResults(hits);
                refreshTracking();
              case 5:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }))();
      } else {
        var itemFilter = {
          hitsPerPage: SearchCount,
          facetFilters: [['type:Curator'], _toConsumableArray(tags)],
          filters: currentPageID ? "NOT objectID:".concat(currentPageID) : ''
        };
        getListing(indexName, itemFilter).then(function (hits) {
          setSearchResults(hits && hits.hits);
        });
      }
    }
  }, [currentPageID, isPersonalised, isVisible]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!fields) {
    console.info('Curator component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", null, "[Curator component is empty: please provide data source]");
    }
    return null;
  }
  var renderTileItems = function renderTileItems(hostLink) {
    var itemsToMap = searchResults;
    if (intentsLength && isPersonalised) {
      itemsToMap = personalizedList;
    }
    return itemsToMap.map(function (item, index) {
      return /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp adjust-height",
        animateOnce: true,
        duration: 1 + index / 3
      }, /*#__PURE__*/React.createElement(CuratorBlock, {
        item: item && item.item ? item.item : item,
        meet: meet,
        analytics: {
          eventsAnalytics: eventsAnalytics,
          params: params
        },
        hostLink: hostLink,
        selectedPrimaryColor: selectedPrimaryColor,
        parentParams: params
      }));
    });
  };
  var validateItems = intentsLength && isPersonalised ? personalizedList : searchResults;
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "curator curator--multiple m10-curators",
    style: styleThemeHexColor,
    ref: ref
  }, validateItems && validateItems.length > 0 && /*#__PURE__*/React.createElement(CarouselProvider, null, function (_ref4) {
    var renderCarousel = _ref4.renderCarousel,
      renderPreviousButton = _ref4.renderPreviousButton,
      renderNextButton = _ref4.renderNextButton,
      renderDots = _ref4.renderDots,
      state = _ref4.state;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "curator__header"
    }, hasCuratorTitle && /*#__PURE__*/React.createElement(Text, {
      tag: "h4",
      className: "curator__title",
      field: curatorTitle
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-pagination__buttons"
    }, /*#__PURE__*/React.createElement("div", {
      className: "btn-group--right ".concat(rtl ? 'btn-group-rtl' : '')
    }, renderPreviousButton(function () {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['prevNavAnalytics'], params));
    }), renderNextButton(function () {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['nextNavAnalytics'], params));
    })))), /*#__PURE__*/React.createElement("div", {
      className: "curator__list ".concat(rtl && get(state, 'slidesToShow') >= get(state, 'totalItems') ? 'item-rtl-carousal-fix' : '')
    }, renderCarousel(renderTileItems(overviewButtonUrl), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 1440
          },
          items: 4
        },
        laptop: {
          breakpoint: {
            max: 1440,
            min: 1100
          },
          items: 3
        },
        tablet_landscape: {
          breakpoint: {
            max: 1100,
            min: 768
          },
          items: 2
        },
        tablet: {
          breakpoint: {
            max: 767,
            min: 560
          },
          items: 2
        },
        mobile: {
          breakpoint: {
            max: 560,
            min: 0
          },
          items: 1
        }
      }
    }, function () {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['mobileSlidesAnalytics'], params));
    })), /*#__PURE__*/React.createElement("div", {
      className: "curator__pagination"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-pagination__link"
    }, pageEditing ? /*#__PURE__*/React.createElement(Text, {
      tag: "span",
      className: "btn-tertiary__text",
      field: overviewButtonTitle
    }) : /*#__PURE__*/React.createElement(RouterLink, {
      className: "btn-tertiary",
      href: overviewButtonUrl + seeMoreURLTags,
      title: "see more",
      "aria-label": "see more",
      onClick: function onClick() {
        return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['discoverMoreClickAnalytics'], params));
      }
    }, hasOverviewButtonTitle && /*#__PURE__*/React.createElement(Text, {
      tag: "span",
      className: "btn-tertiary__text",
      field: overviewButtonTitle
    }), /*#__PURE__*/React.createElement(IconChevronRightLight, {
      className: "btn-tertiary__icon btn-link-icon"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "c-pagination__dots"
    }, renderDots(function () {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['navBubblesAnalytics'], params));
    }))));
  })));
};
var StyledWrapper = function StyledWrapper(_ref5) {
  var children = _ref5.children,
    rtl = _ref5.rtl,
    anchorUrlParameter = _ref5.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true,
    className: " ".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
export var commonStyles = "c1s9hply";
export var ltrStyles = "l13n7n00";
export var rtlStyles = "r13b4s7f";
export default Curators;